import React from 'react';
import ReactDOM from 'react-dom';
import classNames from "classnames/bind";

import {Button} from "../Button";
import {ReactComponent as InfoIcon} from "../../icons/info.svg"

import styles from "./CancelModal.module.css";

const cx = classNames.bind(styles);

type Props = {
  isOpen: boolean,
  handleClose: () => void,
};

export const CancelModal: React.FC<Props> = ({isOpen, handleClose}) => {
  if (!isOpen) return null;

  const onOverlayClick = (e: any) => {
    handleClose();
    e.stopPropagation();
  };

  const onModalClick = (e: any) => {
    e.stopPropagation()
  }

  const cancelHandler = () => {
    window.parent.postMessage(
      JSON.stringify({ selftest_status: "REGISTRATION_CANCELLED" }),
      "*"
    );
    localStorage.clear();
    window.location.reload();
  }


  return ReactDOM.createPortal(
    <div className={cx("modal")} onClick={onOverlayClick}>
      <div
        className={cx("modal_content")}
        onClick={onModalClick}
      >
        <div className={cx("modal_icon")}>
          <InfoIcon width={24} height={24} />
        </div>
        <p className={cx("modal_text")}>Этим действием все ваши ответы будут утеряны.</p>
        <p className={cx("modal_text")}>Вы точно хотите прервать прохождение теста?</p>
        <div className={cx("actions")}>
          <Button
            color="white"
            block
            size="medium"
            rounded
            type="button"
            onClick={handleClose}
          >
            Отмена
          </Button>
          <Button
            color="cerulean"
            block
            size="medium"
            rounded
            type="button"
            onClick={cancelHandler}
          >
            Прервать
          </Button>
        </div>
      </div>
    </div>,
    document.getElementById("wrapper")!)
}